import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

import {AdScrollRevealDefaultSmall, AdScrollRevealDefaultMedium, AdScrollRevealDefaultBig } from '../lib/ad-scroll'
import parallax from '../lib/class-parallax'

gsap.registerPlugin(ScrollTrigger)

/* Animation on scroll */

export const aosScroll = () => {
	document.addEventListener('DOMContentLoaded', function () {

		let animScroll = gsap.timeline({
			scrollTrigger: {
				trigger: '.arrowScroll',
				start: 'top 90%',
			},
		})
		animScroll.to('.arrowScroll', {
			strokeDashoffset: 0,
			duration: 4,
		})

		AdScrollRevealDefaultSmall({
			classTarget: '.scroll_reveal-default-s',
		})

		AdScrollRevealDefaultMedium({
			classTarget: '.scroll_reveal-default-m',
		})

		AdScrollRevealDefaultBig({
			classTarget: '.scroll_reveal-default-b',
		})

	})
}

/* Parallax */

export const parallaxScroll = () => {
	document.addEventListener('DOMContentLoaded', function () {
		/* 4k */ /* desktop */ /* laptop */
		new parallax({
			target: '.parallax',
			top : 'top 115%',
			bottom : 'bottom -115%',
			start: -20,
			end: 20,
		})
		
	})
}

